import { Track } from "@/src/lib/tracking";
import { useMemo } from "react";
import { safeStringifyError } from "utils";
import { useOspApiClientProvider } from "@/src/hooks/useOspApiClientProvider";
import type {
  OnboardingApi,
  OnboardingFinishRequest,
  OnboardingInitResponse,
  OnboardingStatusResult,
} from "./types";
import { ONBOARDING_STAGE_COMPLETED } from "./types";

const EMPTY_ONBOARDING_STATE: OnboardingInitResponse = {
  steps: [],
};

/** 无法确认状态时默认允许进入 onboarding，避免误判为 completed */
const ONBOARDING_STATUS_UNAVAILABLE: OnboardingStatusResult = {
  shouldEnter: true,
  unavailable: true,
};

export const useChatOnboardingApi = (): OnboardingApi => {
  const { chatApi } = useOspApiClientProvider();

  return useMemo(
    () => ({
      getInitialState: async () => {
        return EMPTY_ONBOARDING_STATE;
      },
      finishOnboarding: async (_payload: OnboardingFinishRequest) => {
        return;
      },
      getOnboardingStatus: async () => {
        try {
          if (!chatApi) {
            Track.log("warn", "useChatOnboardingApi", "chatApi unavailable");
            return ONBOARDING_STATUS_UNAVAILABLE;
          }
          const res = await chatApi.user.onboardingStatusList();
          if (res?.error) {
            Track.log(
              "warn",
              "useChatOnboardingApi",
              "onboarding status fetch failed",
              { cause: String(safeStringifyError(res.error)) },
            );
            return ONBOARDING_STATUS_UNAVAILABLE;
          }
          const onboardingStage = res?.data?.onboardingStage;
          const shouldEnter = onboardingStage !== ONBOARDING_STAGE_COMPLETED;
          Track.log(
            "info",
            "useChatOnboardingApi",
            "onboarding status resolved",
            {
              onboardingStage,
              shouldEnter,
            },
          );
          return { onboardingStage, shouldEnter };
        } catch (e) {
          Track.log(
            "warn",
            "useChatOnboardingApi",
            "onboarding status check failed",
            { cause: String(safeStringifyError(e)) },
          );
          return ONBOARDING_STATUS_UNAVAILABLE;
        }
      },
    }),
    [chatApi],
  );
};
